import { createRouter, createWebHistory } from 'vue-router'
import { ReviseMeta } from '@/util/meta'
import { deviceType } from '@/util/base'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    // 入口页面 预约期 官网先展示预约
    {
      path: '/',
      component: () => import('./views/yy/index.vue'),
      meta: {
        title: '<삼국지: 구주제패> 사전예약 진행 중! 신장 조운 무료 획득 & 첫 주 333회 무료 모집｜실시간 전략 삼국 SLG',
        keywords:
          '삼국지: 구주제패, 구주제패, 삼국군영전, 삼국군영전: 구주제패, 삼국군영전 SLG, 구주제패 사전예약, 구주제패 사전등록, 삼국군영전 모바일, 정통 삼국군영전, 삼국지 전략판, 천하를 탐하다, 인피니트 보더스, 삼국지: 천하결전, 라이즈 오브 킹덤즈, 삼국, 삼국지, 진짜 삼국지, 입체전장, SLG, 전략 게임, 실시간 전략, RTS, 모바일 게임, 무료 게임, 실시간 전략, 실시간 전투 사전예약, 사전등록, 모바일 게임 사전예약, 사전예약 공식 홈페이지 길 건설 없는 개척, 길 건설 없는 SLG, 즉시 주성 이동, 건물 즉시 업그레이드, 다중 소탕, 손실 없는 장수 교체, 레벨 공명, 자유 행군, 리얼 지형, 3D 삼국, 육해공 전장, 무장 공명, 전용 무기 필중, 픽업 락 없음, 국전, 공성, 연맹 집결, 혜자 SLG, 부담 없는 SLG, 400회 뽑기, 무료 조운, 2026 신작 SLG, 3D 샌드박스 전략, 전쟁 전략 모바일 게임, 낙양 쟁탈전, 1억 원 상금 대회, 상금전, 레이스 관우, 조운, 제갈량, 조조, 유비, 여포, 주유, 초선, 무장 육성, 병력 배치, 병종 상성, 삼국 모바일 게임 추천, SEA 삼국 게임, Giftcode',
        description:
          '실시간 지휘, 전략으로 지배하라! 지금 <삼국지: 구주제패> 사전예약에 참여하고 신장 조운을 무료로 획득하세요! 첫 주 333회 무료 모집 혜택까지 누려보세요! 입체전장을 구현한 공중·지상 연계 전투로 평면의 한계를 넘어보세요. 무장 레벨 공유로 새로운 조합도 즉시 전투에 투입할 수 있습니다. 자동 공성, 부대 위임, 야간 통행 금지 등 편의 기능을 통해 순수한 전략의 재미를 만나보세요.'
      }
    },
    {
      path: '/m',
      component: () => import('./views/yy/index.vue'),
      meta: {
        title: '<삼국지: 구주제패> 사전예약 진행 중! 신장 조운 무료 획득 & 첫 주 333회 무료 모집｜실시간 전략 삼국 SLG',
        keywords:
          '삼국지: 구주제패, 구주제패, 삼국군영전, 삼국군영전: 구주제패, 삼국군영전 SLG, 구주제패 사전예약, 구주제패 사전등록, 삼국군영전 모바일, 정통 삼국군영전, 삼국지 전략판, 천하를 탐하다, 인피니트 보더스, 삼국지: 천하결전, 라이즈 오브 킹덤즈, 삼국, 삼국지, 진짜 삼국지, 입체전장, SLG, 전략 게임, 실시간 전략, RTS, 모바일 게임, 무료 게임, 실시간 전략, 실시간 전투 사전예약, 사전등록, 모바일 게임 사전예약, 사전예약 공식 홈페이지 길 건설 없는 개척, 길 건설 없는 SLG, 즉시 주성 이동, 건물 즉시 업그레이드, 다중 소탕, 손실 없는 장수 교체, 레벨 공명, 자유 행군, 리얼 지형, 3D 삼국, 육해공 전장, 무장 공명, 전용 무기 필중, 픽업 락 없음, 국전, 공성, 연맹 집결, 혜자 SLG, 부담 없는 SLG, 400회 뽑기, 무료 조운, 2026 신작 SLG, 3D 샌드박스 전략, 전쟁 전략 모바일 게임, 낙양 쟁탈전, 1억 원 상금 대회, 상금전, 레이스 관우, 조운, 제갈량, 조조, 유비, 여포, 주유, 초선, 무장 육성, 병력 배치, 병종 상성, 삼국 모바일 게임 추천, SEA 삼국 게임, Giftcode',
        description:
          '실시간 지휘, 전략으로 지배하라! 지금 <삼국지: 구주제패> 사전예약에 참여하고 신장 조운을 무료로 획득하세요! 첫 주 333회 무료 모집 혜택까지 누려보세요! 입체전장을 구현한 공중·지상 연계 전투로 평면의 한계를 넘어보세요. 무장 레벨 공유로 새로운 조합도 즉시 전투에 투입할 수 있습니다. 자동 공성, 부대 위임, 야간 통행 금지 등 편의 기능을 통해 순수한 전략의 재미를 만나보세요.'
      }
    },
    {
      path: '/pre',
      component: () => import('./views/yy/index.vue'),
      meta: {
        title: '<삼국지: 구주제패> 사전예약 진행 중! 신장 조운 무료 획득 & 첫 주 333회 무료 모집｜실시간 전략 삼국 SLG',
        keywords:
          '삼국지: 구주제패, 구주제패, 삼국군영전, 삼국군영전: 구주제패, 삼국군영전 SLG, 구주제패 사전예약, 구주제패 사전등록, 삼국군영전 모바일, 정통 삼국군영전, 삼국지 전략판, 천하를 탐하다, 인피니트 보더스, 삼국지: 천하결전, 라이즈 오브 킹덤즈, 삼국, 삼국지, 진짜 삼국지, 입체전장, SLG, 전략 게임, 실시간 전략, RTS, 모바일 게임, 무료 게임, 실시간 전략, 실시간 전투 사전예약, 사전등록, 모바일 게임 사전예약, 사전예약 공식 홈페이지 길 건설 없는 개척, 길 건설 없는 SLG, 즉시 주성 이동, 건물 즉시 업그레이드, 다중 소탕, 손실 없는 장수 교체, 레벨 공명, 자유 행군, 리얼 지형, 3D 삼국, 육해공 전장, 무장 공명, 전용 무기 필중, 픽업 락 없음, 국전, 공성, 연맹 집결, 혜자 SLG, 부담 없는 SLG, 400회 뽑기, 무료 조운, 2026 신작 SLG, 3D 샌드박스 전략, 전쟁 전략 모바일 게임, 낙양 쟁탈전, 1억 원 상금 대회, 상금전, 레이스 관우, 조운, 제갈량, 조조, 유비, 여포, 주유, 초선, 무장 육성, 병력 배치, 병종 상성, 삼국 모바일 게임 추천, SEA 삼국 게임, Giftcode',
        description:
          '실시간 지휘, 전략으로 지배하라! 지금 <삼국지: 구주제패> 사전예약에 참여하고 신장 조운을 무료로 획득하세요! 첫 주 333회 무료 모집 혜택까지 누려보세요! 입체전장을 구현한 공중·지상 연계 전투로 평면의 한계를 넘어보세요. 무장 레벨 공유로 새로운 조합도 즉시 전투에 투입할 수 있습니다. 자동 공성, 부대 위임, 야간 통행 금지 등 편의 기능을 통해 순수한 전략의 재미를 만나보세요.'
      }
    },
    {
      path: '/pre/m',
      component: () => import('./views/yy/index.vue'),
      meta: {
        title: '<삼국지: 구주제패> 사전예약 진행 중! 신장 조운 무료 획득 & 첫 주 333회 무료 모집｜실시간 전략 삼국 SLG',
        keywords:
          '삼국지: 구주제패, 구주제패, 삼국군영전, 삼국군영전: 구주제패, 삼국군영전 SLG, 구주제패 사전예약, 구주제패 사전등록, 삼국군영전 모바일, 정통 삼국군영전, 삼국지 전략판, 천하를 탐하다, 인피니트 보더스, 삼국지: 천하결전, 라이즈 오브 킹덤즈, 삼국, 삼국지, 진짜 삼국지, 입체전장, SLG, 전략 게임, 실시간 전략, RTS, 모바일 게임, 무료 게임, 실시간 전략, 실시간 전투 사전예약, 사전등록, 모바일 게임 사전예약, 사전예약 공식 홈페이지 길 건설 없는 개척, 길 건설 없는 SLG, 즉시 주성 이동, 건물 즉시 업그레이드, 다중 소탕, 손실 없는 장수 교체, 레벨 공명, 자유 행군, 리얼 지형, 3D 삼국, 육해공 전장, 무장 공명, 전용 무기 필중, 픽업 락 없음, 국전, 공성, 연맹 집결, 혜자 SLG, 부담 없는 SLG, 400회 뽑기, 무료 조운, 2026 신작 SLG, 3D 샌드박스 전략, 전쟁 전략 모바일 게임, 낙양 쟁탈전, 1억 원 상금 대회, 상금전, 레이스 관우, 조운, 제갈량, 조조, 유비, 여포, 주유, 초선, 무장 육성, 병력 배치, 병종 상성, 삼국 모바일 게임 추천, SEA 삼국 게임, Giftcode',
        description:
          '실시간 지휘, 전략으로 지배하라! 지금 <삼국지: 구주제패> 사전예약에 참여하고 신장 조운을 무료로 획득하세요! 첫 주 333회 무료 모집 혜택까지 누려보세요! 입체전장을 구현한 공중·지상 연계 전투로 평면의 한계를 넘어보세요. 무장 레벨 공유로 새로운 조합도 즉시 전투에 투입할 수 있습니다. 자동 공성, 부대 위임, 야간 통행 금지 등 편의 기능을 통해 순수한 전략의 재미를 만나보세요.'
      }
    },
    {
      path: '/pre/FB',
      component: () => import('./views/yy/index.vue'),
      meta: {
        title: '<삼국지: 구주제패> 사전예약 진행 중! 신장 조운 무료 획득 & 첫 주 333회 무료 모집｜실시간 전략 삼국 SLG',
        keywords:
          '삼국지: 구주제패, 구주제패, 삼국군영전, 삼국군영전: 구주제패, 삼국군영전 SLG, 구주제패 사전예약, 구주제패 사전등록, 삼국군영전 모바일, 정통 삼국군영전, 삼국지 전략판, 천하를 탐하다, 인피니트 보더스, 삼국지: 천하결전, 라이즈 오브 킹덤즈, 삼국, 삼국지, 진짜 삼국지, 입체전장, SLG, 전략 게임, 실시간 전략, RTS, 모바일 게임, 무료 게임, 실시간 전략, 실시간 전투 사전예약, 사전등록, 모바일 게임 사전예약, 사전예약 공식 홈페이지 길 건설 없는 개척, 길 건설 없는 SLG, 즉시 주성 이동, 건물 즉시 업그레이드, 다중 소탕, 손실 없는 장수 교체, 레벨 공명, 자유 행군, 리얼 지형, 3D 삼국, 육해공 전장, 무장 공명, 전용 무기 필중, 픽업 락 없음, 국전, 공성, 연맹 집결, 혜자 SLG, 부담 없는 SLG, 400회 뽑기, 무료 조운, 2026 신작 SLG, 3D 샌드박스 전략, 전쟁 전략 모바일 게임, 낙양 쟁탈전, 1억 원 상금 대회, 상금전, 레이스 관우, 조운, 제갈량, 조조, 유비, 여포, 주유, 초선, 무장 육성, 병력 배치, 병종 상성, 삼국 모바일 게임 추천, SEA 삼국 게임, Giftcode',
        description:
          '실시간 지휘, 전략으로 지배하라! 지금 <삼국지: 구주제패> 사전예약에 참여하고 신장 조운을 무료로 획득하세요! 첫 주 333회 무료 모집 혜택까지 누려보세요! 입체전장을 구현한 공중·지상 연계 전투로 평면의 한계를 넘어보세요. 무장 레벨 공유로 새로운 조합도 즉시 전투에 투입할 수 있습니다. 자동 공성, 부대 위임, 야간 통행 금지 등 편의 기능을 통해 순수한 전략의 재미를 만나보세요.'
      }
    },
    {
      path: '/pre/FB/m',
      component: () => import('./views/yy/index.vue'),
      meta: {
        title: '<삼국지: 구주제패> 사전예약 진행 중! 신장 조운 무료 획득 & 첫 주 333회 무료 모집｜실시간 전략 삼국 SLG',
        keywords:
          '삼국지: 구주제패, 구주제패, 삼국군영전, 삼국군영전: 구주제패, 삼국군영전 SLG, 구주제패 사전예약, 구주제패 사전등록, 삼국군영전 모바일, 정통 삼국군영전, 삼국지 전략판, 천하를 탐하다, 인피니트 보더스, 삼국지: 천하결전, 라이즈 오브 킹덤즈, 삼국, 삼국지, 진짜 삼국지, 입체전장, SLG, 전략 게임, 실시간 전략, RTS, 모바일 게임, 무료 게임, 실시간 전략, 실시간 전투 사전예약, 사전등록, 모바일 게임 사전예약, 사전예약 공식 홈페이지 길 건설 없는 개척, 길 건설 없는 SLG, 즉시 주성 이동, 건물 즉시 업그레이드, 다중 소탕, 손실 없는 장수 교체, 레벨 공명, 자유 행군, 리얼 지형, 3D 삼국, 육해공 전장, 무장 공명, 전용 무기 필중, 픽업 락 없음, 국전, 공성, 연맹 집결, 혜자 SLG, 부담 없는 SLG, 400회 뽑기, 무료 조운, 2026 신작 SLG, 3D 샌드박스 전략, 전쟁 전략 모바일 게임, 낙양 쟁탈전, 1억 원 상금 대회, 상금전, 레이스 관우, 조운, 제갈량, 조조, 유비, 여포, 주유, 초선, 무장 육성, 병력 배치, 병종 상성, 삼국 모바일 게임 추천, SEA 삼국 게임, Giftcode',
        description:
          '실시간 지휘, 전략으로 지배하라! 지금 <삼국지: 구주제패> 사전예약에 참여하고 신장 조운을 무료로 획득하세요! 첫 주 333회 무료 모집 혜택까지 누려보세요! 입체전장을 구현한 공중·지상 연계 전투로 평면의 한계를 넘어보세요. 무장 레벨 공유로 새로운 조합도 즉시 전투에 투입할 수 있습니다. 자동 공성, 부대 위임, 야간 통행 금지 등 편의 기능을 통해 순수한 전략의 재미를 만나보세요.'
      }
    },
    {
      path: '/pre/GG',
      component: () => import('./views/yy/index.vue'),
      meta: {
        title: '<삼국지: 구주제패> 사전예약 진행 중! 신장 조운 무료 획득 & 첫 주 333회 무료 모집｜실시간 전략 삼국 SLG',
        keywords:
          '삼국지: 구주제패, 구주제패, 삼국군영전, 삼국군영전: 구주제패, 삼국군영전 SLG, 구주제패 사전예약, 구주제패 사전등록, 삼국군영전 모바일, 정통 삼국군영전, 삼국지 전략판, 천하를 탐하다, 인피니트 보더스, 삼국지: 천하결전, 라이즈 오브 킹덤즈, 삼국, 삼국지, 진짜 삼국지, 입체전장, SLG, 전략 게임, 실시간 전략, RTS, 모바일 게임, 무료 게임, 실시간 전략, 실시간 전투 사전예약, 사전등록, 모바일 게임 사전예약, 사전예약 공식 홈페이지 길 건설 없는 개척, 길 건설 없는 SLG, 즉시 주성 이동, 건물 즉시 업그레이드, 다중 소탕, 손실 없는 장수 교체, 레벨 공명, 자유 행군, 리얼 지형, 3D 삼국, 육해공 전장, 무장 공명, 전용 무기 필중, 픽업 락 없음, 국전, 공성, 연맹 집결, 혜자 SLG, 부담 없는 SLG, 400회 뽑기, 무료 조운, 2026 신작 SLG, 3D 샌드박스 전략, 전쟁 전략 모바일 게임, 낙양 쟁탈전, 1억 원 상금 대회, 상금전, 레이스 관우, 조운, 제갈량, 조조, 유비, 여포, 주유, 초선, 무장 육성, 병력 배치, 병종 상성, 삼국 모바일 게임 추천, SEA 삼국 게임, Giftcode',
        description:
          '실시간 지휘, 전략으로 지배하라! 지금 <삼국지: 구주제패> 사전예약에 참여하고 신장 조운을 무료로 획득하세요! 첫 주 333회 무료 모집 혜택까지 누려보세요! 입체전장을 구현한 공중·지상 연계 전투로 평면의 한계를 넘어보세요. 무장 레벨 공유로 새로운 조합도 즉시 전투에 투입할 수 있습니다. 자동 공성, 부대 위임, 야간 통행 금지 등 편의 기능을 통해 순수한 전략의 재미를 만나보세요.'
      }
    },
    {
      path: '/pre/GG/m',
      component: () => import('./views/yy/index.vue'),
      meta: {
        title: '<삼국지: 구주제패> 사전예약 진행 중! 신장 조운 무료 획득 & 첫 주 333회 무료 모집｜실시간 전략 삼국 SLG',
        keywords:
          '삼국지: 구주제패, 구주제패, 삼국군영전, 삼국군영전: 구주제패, 삼국군영전 SLG, 구주제패 사전예약, 구주제패 사전등록, 삼국군영전 모바일, 정통 삼국군영전, 삼국지 전략판, 천하를 탐하다, 인피니트 보더스, 삼국지: 천하결전, 라이즈 오브 킹덤즈, 삼국, 삼국지, 진짜 삼국지, 입체전장, SLG, 전략 게임, 실시간 전략, RTS, 모바일 게임, 무료 게임, 실시간 전략, 실시간 전투 사전예약, 사전등록, 모바일 게임 사전예약, 사전예약 공식 홈페이지 길 건설 없는 개척, 길 건설 없는 SLG, 즉시 주성 이동, 건물 즉시 업그레이드, 다중 소탕, 손실 없는 장수 교체, 레벨 공명, 자유 행군, 리얼 지형, 3D 삼국, 육해공 전장, 무장 공명, 전용 무기 필중, 픽업 락 없음, 국전, 공성, 연맹 집결, 혜자 SLG, 부담 없는 SLG, 400회 뽑기, 무료 조운, 2026 신작 SLG, 3D 샌드박스 전략, 전쟁 전략 모바일 게임, 낙양 쟁탈전, 1억 원 상금 대회, 상금전, 레이스 관우, 조운, 제갈량, 조조, 유비, 여포, 주유, 초선, 무장 육성, 병력 배치, 병종 상성, 삼국 모바일 게임 추천, SEA 삼국 게임, Giftcode',
        description:
          '실시간 지휘, 전략으로 지배하라! 지금 <삼국지: 구주제패> 사전예약에 참여하고 신장 조운을 무료로 획득하세요! 첫 주 333회 무료 모집 혜택까지 누려보세요! 입체전장을 구현한 공중·지상 연계 전투로 평면의 한계를 넘어보세요. 무장 레벨 공유로 새로운 조합도 즉시 전투에 투입할 수 있습니다. 자동 공성, 부대 위임, 야간 통행 금지 등 편의 기능을 통해 순수한 전략의 재미를 만나보세요.'
      }
    },
    {
      path: '/pre/TT',
      component: () => import('./views/yy/index.vue'),
      meta: {
        title: '<삼국지: 구주제패> 사전예약 진행 중! 신장 조운 무료 획득 & 첫 주 333회 무료 모집｜실시간 전략 삼국 SLG',
        keywords:
          '삼국지: 구주제패, 구주제패, 삼국군영전, 삼국군영전: 구주제패, 삼국군영전 SLG, 구주제패 사전예약, 구주제패 사전등록, 삼국군영전 모바일, 정통 삼국군영전, 삼국지 전략판, 천하를 탐하다, 인피니트 보더스, 삼국지: 천하결전, 라이즈 오브 킹덤즈, 삼국, 삼국지, 진짜 삼국지, 입체전장, SLG, 전략 게임, 실시간 전략, RTS, 모바일 게임, 무료 게임, 실시간 전략, 실시간 전투 사전예약, 사전등록, 모바일 게임 사전예약, 사전예약 공식 홈페이지 길 건설 없는 개척, 길 건설 없는 SLG, 즉시 주성 이동, 건물 즉시 업그레이드, 다중 소탕, 손실 없는 장수 교체, 레벨 공명, 자유 행군, 리얼 지형, 3D 삼국, 육해공 전장, 무장 공명, 전용 무기 필중, 픽업 락 없음, 국전, 공성, 연맹 집결, 혜자 SLG, 부담 없는 SLG, 400회 뽑기, 무료 조운, 2026 신작 SLG, 3D 샌드박스 전략, 전쟁 전략 모바일 게임, 낙양 쟁탈전, 1억 원 상금 대회, 상금전, 레이스 관우, 조운, 제갈량, 조조, 유비, 여포, 주유, 초선, 무장 육성, 병력 배치, 병종 상성, 삼국 모바일 게임 추천, SEA 삼국 게임, Giftcode',
        description:
          '실시간 지휘, 전략으로 지배하라! 지금 <삼국지: 구주제패> 사전예약에 참여하고 신장 조운을 무료로 획득하세요! 첫 주 333회 무료 모집 혜택까지 누려보세요! 입체전장을 구현한 공중·지상 연계 전투로 평면의 한계를 넘어보세요. 무장 레벨 공유로 새로운 조합도 즉시 전투에 투입할 수 있습니다. 자동 공성, 부대 위임, 야간 통행 금지 등 편의 기능을 통해 순수한 전략의 재미를 만나보세요.'
      }
    },
    {
      path: '/pre/TT/m',
      component: () => import('./views/yy/index.vue'),
      meta: {
        title: '<삼국지: 구주제패> 사전예약 진행 중! 신장 조운 무료 획득 & 첫 주 333회 무료 모집｜실시간 전략 삼국 SLG',
        keywords:
          '삼국지: 구주제패, 구주제패, 삼국군영전, 삼국군영전: 구주제패, 삼국군영전 SLG, 구주제패 사전예약, 구주제패 사전등록, 삼국군영전 모바일, 정통 삼국군영전, 삼국지 전략판, 천하를 탐하다, 인피니트 보더스, 삼국지: 천하결전, 라이즈 오브 킹덤즈, 삼국, 삼국지, 진짜 삼국지, 입체전장, SLG, 전략 게임, 실시간 전략, RTS, 모바일 게임, 무료 게임, 실시간 전략, 실시간 전투 사전예약, 사전등록, 모바일 게임 사전예약, 사전예약 공식 홈페이지 길 건설 없는 개척, 길 건설 없는 SLG, 즉시 주성 이동, 건물 즉시 업그레이드, 다중 소탕, 손실 없는 장수 교체, 레벨 공명, 자유 행군, 리얼 지형, 3D 삼국, 육해공 전장, 무장 공명, 전용 무기 필중, 픽업 락 없음, 국전, 공성, 연맹 집결, 혜자 SLG, 부담 없는 SLG, 400회 뽑기, 무료 조운, 2026 신작 SLG, 3D 샌드박스 전략, 전쟁 전략 모바일 게임, 낙양 쟁탈전, 1억 원 상금 대회, 상금전, 레이스 관우, 조운, 제갈량, 조조, 유비, 여포, 주유, 초선, 무장 육성, 병력 배치, 병종 상성, 삼국 모바일 게임 추천, SEA 삼국 게임, Giftcode',
        description:
          '실시간 지휘, 전략으로 지배하라! 지금 <삼국지: 구주제패> 사전예약에 참여하고 신장 조운을 무료로 획득하세요! 첫 주 333회 무료 모집 혜택까지 누려보세요! 입체전장을 구현한 공중·지상 연계 전투로 평면의 한계를 넘어보세요. 무장 레벨 공유로 새로운 조합도 즉시 전투에 투입할 수 있습니다. 자동 공성, 부대 위임, 야간 통행 금지 등 편의 기능을 통해 순수한 전략의 재미를 만나보세요.'
      }
    },
    // 备战盟
    {
      path: '/alliance/:type(m)?',
      component: () => import('./views/alliance/index.vue')
    },
    // 下载
    {
      path: '/down/:version',
      meta: {
        title: '<삼국지: 구주제패> 사전예약 진행 중! 신장 조운 무료 획득 & 첫 주 333회 무료 모집｜실시간 전략 삼국 SLG',
        keywords:
          '삼국지: 구주제패, 구주제패, 삼국군영전, 삼국군영전: 구주제패, 삼국군영전 SLG, 구주제패 사전예약, 구주제패 사전등록, 삼국군영전 모바일, 정통 삼국군영전, 삼국지 전략판, 천하를 탐하다, 인피니트 보더스, 삼국지: 천하결전, 라이즈 오브 킹덤즈, 삼국, 삼국지, 진짜 삼국지, 입체전장, SLG, 전략 게임, 실시간 전략, RTS, 모바일 게임, 무료 게임, 실시간 전략, 실시간 전투 사전예약, 사전등록, 모바일 게임 사전예약, 사전예약 공식 홈페이지 길 건설 없는 개척, 길 건설 없는 SLG, 즉시 주성 이동, 건물 즉시 업그레이드, 다중 소탕, 손실 없는 장수 교체, 레벨 공명, 자유 행군, 리얼 지형, 3D 삼국, 육해공 전장, 무장 공명, 전용 무기 필중, 픽업 락 없음, 국전, 공성, 연맹 집결, 혜자 SLG, 부담 없는 SLG, 400회 뽑기, 무료 조운, 2026 신작 SLG, 3D 샌드박스 전략, 전쟁 전략 모바일 게임, 낙양 쟁탈전, 1억 원 상금 대회, 상금전, 레이스 관우, 조운, 제갈량, 조조, 유비, 여포, 주유, 초선, 무장 육성, 병력 배치, 병종 상성, 삼국 모바일 게임 추천, SEA 삼국 게임, Giftcode',
        description:
          '실시간 지휘, 전략으로 지배하라! 지금 <삼국지: 구주제패> 사전예약에 참여하고 신장 조운을 무료로 획득하세요! 첫 주 333회 무료 모집 혜택까지 누려보세요! 입체전장을 구현한 공중·지상 연계 전투로 평면의 한계를 넘어보세요. 무장 레벨 공유로 새로운 조합도 즉시 전투에 투입할 수 있습니다. 자동 공성, 부대 위임, 야간 통행 금지 등 편의 기능을 통해 순수한 전략의 재미를 만나보세요.'
      },
      component: () => import('./views/down/index.vue')
    },
    // 404
    {
      path: '/:pathMatch(.*)*',
      component: () => import('../../components/404.vue')
    }
  ]
})
router.beforeEach((to, from, next) => {
  // 路由发生变化改变 description 和 keyword
  ReviseMeta(to.meta.title, to.meta.keywords, to.meta.description)

  // 定义特殊页面白名单，使用正则表达式匹配通配符
  const specialPages = [/^\/down(\/.*)?$/]

  // 检查当前路径是否在特殊页面白名单中
  const isSpecialPage = specialPages.some((pattern) => pattern.test(to.path))

  // 如果是特殊页面，直接调用 next()
  if (isSpecialPage) {
    next()
    return
  }

  const isWap = deviceType() == 'wap'

  // 定义PC端和移动端路径
  let pcPath = to.path.replace(/\/m$/, '')
  let wapPath = pcPath.endsWith('/') ? `${pcPath}m` : `${pcPath}/m`

  // 根据设备类型跳转，避免重复添加或删除斜杠
  if (isWap && !to.path.endsWith('/m')) {
    next({ path: wapPath, query: to.query })
  } else if (!isWap && to.path.endsWith('/m')) {
    next({ path: pcPath, query: to.query })
  } else {
    next()
  }
})

export default router
